import { useCallback } from 'react'
import { ExistingBlockList } from '../BuilderExistingBlockPicker'

/**
 * Éditeur du champ `shared-unit-ref` — changer la cible d'un bloc partagé.
 *
 * Le porteur (`SharedBlock`) ne stocke qu'un pointeur `{nid, type, label}` : tout
 * le contenu vit dans l'unité visée, et reste donc commun à toutes ses places.
 * Rendu NU dans le popover ancré à la pastille du porteur (règle UX du builder :
 * l'édition se fait en place, jamais en modale) — d'où la réutilisation de la
 * liste seule, sans la chrome de dialogue de « Ajouter un bloc existant ».
 */
export const SharedUnitRefEditor = ({ value, onSave, onClose }) => {
  const handlePick = useCallback((item) => {
    onSave({ nid: item.nid, type: item.type, label: item.excerpt || item.label })
    onClose?.()
  }, [onSave, onClose])

  return (
    <div className="flex w-[28rem] max-w-full flex-col">
      <ExistingBlockList value={value} onPick={handlePick} compact />
    </div>
  )
}
